import React, { useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import MLGUI from "../asset/MLGUI.png";
import "../css/navigation.css";
import AuthContext from "../context/AuthContext";


const Navigation = () => {
  let { user, logoutUser } = useContext(AuthContext);

  
  // let {data} = useContext(DataDescriptionContext);
  // console.log("testing for",data)
  return (<>
      {user?(
        <div className="container-fluid">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <NavLink className="navbar-brand ms-2" to="">
              <img className="navbar-logo" src={MLGUI} alt="MLGUI"></img>
            </NavLink>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarText"
              aria-controls="navbarText"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarText">
              <ul className="navbar-nav ms-1 me-auto mb-2 mb-lg-0">
                <li className="nav-item mx-1">
                  <NavLink
                    className={({ isActive }) => (isActive ? 'nav-link text-light h5 activesidenav' : 'nav-link text-light h5')}
                    aria-current="page"
                    to="/" 
                  ><i className="bi text-primary bi-house-gear"></i>
                    <span>Home</span>
                  </NavLink>
                </li>
                <li className="nav-item mx-1">
                  <NavLink className={({ isActive }) => (isActive ? 'nav-link text-light h5 activesidenav' : 'nav-link text-light h5')} to="/docs" >
                  <i className="bi text-primary bi-filetype-doc"></i>
                    <span>Docs</span>
                  </NavLink>
                </li>
                {/* <li className="nav-item mx-1">
                  <NavLink className={({ isActive }) => (isActive ? 'nav-link text-light h5 activesidenav' : 'nav-link text-light h5')} to="/help" ><i class="bi text-primary bi-question-diamond-fill"></i>
                    Help
                  </NavLink>
                </li> */}
                <li className="nav-item mx-1">
                  <NavLink className={({ isActive }) => (isActive ? 'nav-link text-light h5 activesidenav' : 'nav-link text-light h5')} to="/feedback" >
                  <i className="fa text-primary fa-comments"></i>
                    Feedback
                  </NavLink>
                </li>
              </ul>
              <ul className="navbar-nav me-5 mb-2 mb-lg-0">
                
                <li>
              <Link to="#" className="nav-link text-light mx-1 h5"  onClick={logoutUser}>
              <i className="bi text-primary bi-box-arrow-left"></i>
                Logout
              </Link>
            </li> 
              </ul>
            </div>
          </div>
        </nav>
        </div>
        ):(
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <NavLink className="navbar-brand ms-2" to="/" >
              <img className="navbar-logo" src={MLGUI} alt="MLGUI"></img>
            </NavLink>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarText"
              aria-controls="navbarText"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarText">
              <ul className="navbar-nav ms-1 me-auto mb-2 mb-lg-0">
                <li className="nav-item mx-1">
                  <NavLink
                    className={({ isActive }) => (isActive ? 'nav-link text-light h5 activesidenav' : 'nav-link text-light h5')}
                    aria-current="page"
                    to="/"
                    
                  ><i className="bi text-primary bi-house-gear"></i> 
                    <span>Home</span>
                  </NavLink>
                </li>
                <li className="nav-item mx-1">
                  <NavLink className={({ isActive }) => (isActive ? 'nav-link text-light h5 activesidenav' : 'nav-link text-light h5')} to="/docs" >
                  <i className="bi text-primary bi-filetype-doc"></i>
                    <span>Docs</span>
                  </NavLink>
                </li>
                {/* <li className="nav-item mx-1">
                  <NavLink className={({ isActive }) => (isActive ? 'nav-link text-light h5 activesidenav' : 'nav-link text-light h5')} to="/help" ><i class="bi text-primary bi-question-diamond-fill"></i>
                   <span>Help</span>
                  </NavLink>
                </li> */}
                <li className="nav-item mx-1">
                  <NavLink className={({ isActive }) => (isActive ? 'nav-link text-light h5 activesidenav' : 'nav-link text-light h5')} to="/feedback" >
                  <i className="fa text-primary fa-comments"></i>
                  <span>Feedback</span>
                  </NavLink>
                </li>
              </ul>
              <ul className="navbar-nav me-5 mb-2 mb-lg-0">
                <li className="nav-item mx-1">
                  <Link className="nav-link text-light mx-1 h5" to="/register" >
                  <i className="bi text-primary bi-box-arrow-in-right"></i>
                    <span>Register</span>
                  </Link>
                </li>
                <li className="nav-item mx-1">
                  <Link className="nav-link text-light mx-1 h5" to="/signin" >
                  <i className="bi text-primary bi-box-arrow-in-right"></i>
                    <span>Login</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      )}
  </>
  );
};

export default Navigation;
